import React, { useEffect } from "react";
import { Wrapper } from "./index.styled";
import FactSheetLeft from "../../Components/FactSheetLeft";
import FactSheetRight from "../../Components/FactSheetRight";
import { useParams, useNavigate } from "react-router-dom"; // ✅ Import useNavigate
import styled from "styled-components";
import { Loader } from "../../App";
import { viewSizeCalculator } from "../../utils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { getHospitalDetail } from "../../services/apiService";

function parseHcahpsData(hcahpsString) {
  return hcahpsString.split(",").map((entry) => {
    const [key, value] = entry.split("-").map((item) => item.trim());

    return {
      [key]: isNaN(value) ? value : Number(value),
    };
  });
}

const FactSheet = ({ toggleState, state }) => {
  const navigate = useNavigate(); // ✅ Initialize navigate
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    //dispatch(resetSelectedState());
    //dispatch(resetSpecificStateData());
  }, []);

  // Hospital detail is cached per id and shared with any other consumer that
  // requests the same hospital (e.g. search navigation).
  const {
    data: rawData,
    isLoading: loading,
    isError,
    error,
  } = useQuery({
    queryKey: ["hospital", "detail", id],
    queryFn: ({ signal }) => getHospitalDetail(id, signal),
    enabled: !!id,
    staleTime: 30 * 60 * 1000,
    retry: false,
  });

  // An empty object means the hospital wasn't found -> treat it as an error so
  // the UI redirects home instead of rendering broken child components.
  const isEmpty = !!rawData && Object.keys(rawData).length === 0;
  const data = isEmpty ? null : rawData ?? null;

  useEffect(() => {
    if (isError || isEmpty) {
      toast.error(
        error?.message || "Something went wrong. Redirecting...",
      );
      const timer = setTimeout(() => navigate("/"), 2000);
      return () => clearTimeout(timer);
    }
  }, [isError, isEmpty, error, navigate]);

  if (loading)
    return (
      <Center>
        <Loader height={viewSizeCalculator(3)} width={viewSizeCalculator(3)} />
      </Center>
    );

  if (!data) return <ToastContainer position="bottom-right" />; // Prevents rendering broken components

  return (
    <>
      <ToastContainer position="bottom-right" />{" "}
      {/* Always render toast container */}
      <Wrapper>
        <FactSheetLeft data={data} toggleState={toggleState} state={state} />
        <FactSheetRight data={data} />
      </Wrapper>
    </>
  );
};

export default FactSheet;

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
